<template>
  <v-app>
    <v-navigation-drawer
      app
      color="primary"
    >
    </v-navigation-drawer>
    <v-main class="derecha">
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
          >
            <v-card
            class="elevation-2"
            tile
          >
            <v-card-title
              class="headline mb-1"
            >
              404
            </v-card-title>
            <v-card-text>
              El elemento que busca no fue encontrado.
            </v-card-text>
            <v-card-actions>
              <v-container
                fluid
              >
                <v-row
                  justify="end"
                >
                  <router-link :to="{ path: '/' }">Volver</router-link>
                </v-row>
              </v-container>
            </v-card-actions>
          </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
    };
  },
};
</script>

<style>
.derecha {
  background-color: rgb(156, 153, 153);
}
</style>



// WEBPACK FOOTER //
// src/views/NotFound.vue